import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Select,
  Drawer,
  Typography,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TProvider } from "../utils/types";
import { getStatusMeta, transactionStatuses } from "../utils/utils";
import { useMedia } from "../context/MediaContext";
import { alpha, useTheme } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs"; // Импортируем dayjs
import { Dayjs } from "dayjs";
import ClearIcon from "@mui/icons-material/Clear";
import { useMethods } from "../hooks/useMethods";
import { translate } from "../utils/currency";
const Filters: React.FC<{
  merchants: TProvider[];
  providers: TProvider[];
  setFilters: React.Dispatch<
    React.SetStateAction<{
      search_query: string;
      type: string[];
      minsum: number | null;
      maxsum: number | null;
      merchid: number[];
      providerid: number[];
      status: string[];
      forMerch: boolean;
      createdFrom: Dayjs | null;
      createdTo: Dayjs | null;
      updatedFrom: Dayjs | null;
      updatedTo: Dayjs | null;
      currency: string;
      payment_method: string;
    }>
  >;
  handleChange: any;
  filterss: any;
  setOpenFilters: React.Dispatch<React.SetStateAction<boolean>>;
  openFilters: boolean;
  fetchRecentTrans: any;
}> = ({
  merchants,
  providers,
  filterss,
  handleChange,
  setOpenFilters,
  openFilters,
  fetchRecentTrans,
  setFilters,
}) => {
  const { isMobile600 } = useMedia();
  const darkTheme = useTheme();
  const { currency, methods } = useMethods();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <Drawer
        anchor="right"
        open={openFilters}
        onClose={() => setOpenFilters(false)}
        hideBackdrop
        ModalProps={{
          disableEnforceFocus: true,
          disableAutoFocus: true,
          disableRestoreFocus: true,
          keepMounted: true,
        }}
        sx={{
          pointerEvents: "none",
          "& .MuiDrawer-paper": {
            pointerEvents: "auto",

            width: "30vw",
            maxWidth: 480,
            minWidth: 360,

            backgroundColor: alpha(darkTheme.palette.background.paper, 0.88),
            backdropFilter: "blur(25px)",
            borderLeft: `1px solid ${darkTheme.palette.divider}`,

            padding: "24px",
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          pb={2}
          sx={{
            borderBottom: `1px solid ${darkTheme.palette.divider}`,
          }}
        >
          <Typography fontSize={20} fontWeight="bold">
            Фильтры
          </Typography>

          <IconButton
            aria-label="Закрыть фильтры"
            onClick={() => setOpenFilters(false)}
            sx={{
              border: `1px solid ${darkTheme.palette.divider}`,
            }}
          >
            <ClearIcon />
          </IconButton>
        </Box>
        <FormControl sx={{ width: "100%", mt: 3 }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Выберите Мерчантов
          </InputLabel>
          <Select
            sx={{
              minHeight: "72px",
            }}
            multiple
            name="merchid"
            value={filterss.merchid.map(
              (merch: number) =>
                merchants.find((or: TProvider) => or.id === merch)?.name,
            )}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  overflow: "auto",
                  gap: 1,
                  maxWidth: "100%",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                {selected.map((value: string) => (
                  <Box
                    key={value}
                    sx={{
                      px: 2,
                      py: 1,
                      borderRadius: "16px",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      whiteSpace: "nowrap",
                      fontWeight: 700,
                      "&:hover": { opacity: 0.85 },
                    }}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
            )}
          >
            {merchants.map((merch) => (
              <MenuItem
                sx={{
                  backgroundColor: filterss.merchid.includes(merch.id)
                    ? alpha(darkTheme.palette.primary.main, 0.12)
                    : "transparent",
                  "&.Mui-selected": {
                    backgroundColor: darkTheme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: darkTheme.palette.primary.main,
                    },
                  },
                }}
                value={merch.name}
                key={merch.id}
              >
                {merch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>{" "}
        <FormControl sx={{ width: "100%", mt: 4.5 }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Выберите Провайдеров
          </InputLabel>
          <Select
            sx={{
              minHeight: "72px",
            }}
            multiple
            name="providerid"
            value={filterss.providerid.map(
              (prov: number) =>
                providers.find((or: TProvider) => or.id === prov)?.name,
            )}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  overflow: "auto",
                  gap: 1,
                  maxWidth: "100%",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                {selected.map((value: string) => (
                  <Box
                    key={value}
                    sx={{
                      px: 2,
                      py: 1,
                      borderRadius: "16px",
                      bgcolor: "primary.main",
                      color: "primary.contrastText",
                      whiteSpace: "nowrap",
                      fontWeight: 700,
                      "&:hover": { opacity: 0.85 },
                    }}
                  >
                    {value}
                  </Box>
                ))}
              </Box>
            )}
          >
            {providers.map((prov) => (
              <MenuItem
                sx={{
                  backgroundColor: filterss.providerid.includes(prov.id)
                    ? alpha(darkTheme.palette.primary.main, 0.12)
                    : "transparent",
                  "&.Mui-selected": {
                    backgroundColor: darkTheme.palette.primary.main,
                    "&:hover": {
                      backgroundColor: darkTheme.palette.primary.main,
                    },
                  },
                }}
                value={prov.name}
                key={prov.id}
              >
                {prov.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ width: "100%", mt: 4.5 }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Сумма от
          </InputLabel>

          <TextField
            value={filterss.minsum ?? ""}
            onChange={(event) =>
              setFilters((prev) => ({
                ...prev,
                minsum:
                  event.target.value === "" ? null : Number(event.target.value),
              }))
            }
            id="rate"
            slotProps={{
              htmlInput: {
                step: "any",
              },
            }}
            type="number"
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: "68px",
                alignItems: "center",
              },
              "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
                top: 6,
              },
            }}
          />
        </FormControl>
        <FormControl sx={{ width: "100%", mt: 4.5 }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Сумма до
          </InputLabel>

          <TextField
            value={filterss.maxsum ?? ""}
            onChange={(event) =>
              setFilters((prev) => ({
                ...prev,
                maxsum:
                  event.target.value === "" ? null : Number(event.target.value),
              }))
            }
            id="rate"
            slotProps={{
              htmlInput: {
                step: "any",
              },
            }}
            type="number"
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: "68px",
                alignItems: "center",
              },
              "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
                top: 6,
              },
            }}
          />
        </FormControl>
        <Box width={"100%"}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: "20px",
              marginTop: "20px",
              transform: "translateY(-10px)",
            }}
          >
            Дата создания от
          </InputLabel>
          <DatePicker
            name="createdFrom"
            onChange={(newValue) =>
              handleChange(
                "createdFrom",
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : null,
              )
            }
            value={filterss.createdFrom ? dayjs(filterss.createdFrom) : null}
            format="DD.MM.YYYY"
            maxDate={dayjs()}
            sx={{ width: "100%" }}
          />
        </Box>
        <Box width={"100%"}>
          <InputLabel
            shrink={true}
            sx={{
              marginTop: "20px",
              fontSize: "20px",
              transform: "translateY(-10px)",
            }}
          >
            Дата создания до
          </InputLabel>
          <DatePicker
            value={filterss.createdTo ? dayjs(filterss.createdTo) : null}
            name="createdTo"
            onChange={(newValue) =>
              handleChange(
                "createdTo",
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : null, //
              )
            }
            format="DD.MM.YYYY"
            minDate={
              filterss.createdFrom
                ? dayjs(filterss.createdFrom)
                : dayjs(new Date())
            }
            maxDate={dayjs()}
            sx={{ width: "100%" }}
          />
        </Box>
        <Box width={"100%"}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: "20px",
              marginTop: "20px",
              transform: "translateY(-10px)",
            }}
          >
            Дата обновления от
          </InputLabel>
          <DatePicker
            name="updatedFrom"
            onChange={(newValue) =>
              handleChange(
                "updatedFrom",
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : null,
              )
            }
            value={filterss.updatedFrom ? dayjs(filterss.updatedFrom) : null}
            format="DD.MM.YYYY"
            maxDate={dayjs()}
            sx={{ width: "100%" }}
          />
        </Box>
        <Box width={"100%"}>
          <InputLabel
            shrink={true}
            sx={{
              marginTop: "20px",
              fontSize: "20px",
              transform: "translateY(-10px)",
            }}
          >
            Дата обновления до
          </InputLabel>
          <DatePicker
            value={filterss.updatedTo ? dayjs(filterss.updatedTo) : null}
            name="updatedTo"
            onChange={(newValue) =>
              handleChange(
                "updatedTo",
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : null, //
              )
            }
            format="DD.MM.YYYY"
            minDate={
              filterss.createdFrom
                ? dayjs(filterss.createdFrom)
                : dayjs(new Date())
            }
            maxDate={dayjs()}
            sx={{ width: "100%" }}
          />
        </Box>
        <FormControl sx={{ mt: 6, width: "100%" }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "17px" : "20px",
              transform: "translateY(-30px)",
            }}
          >
            Выберите статус транзакций
          </InputLabel>
          <Select
            sx={{
              minHeight: "65px",
            }}
            multiple
            name="status"
            value={filterss.status}
            onChange={(event) => handleChange(event.target.name, event)}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value: string) => {
                  const meta = getStatusMeta(value);
                  return (
                    <Chip
                      key={value}
                      label={meta.label}
                      sx={{
                        fontWeight: 700,
                        color: meta.color,
                        backgroundColor: alpha(meta.color, 0.14),
                        border: `1px solid ${alpha(meta.color, 0.35)}`,
                      }}
                    />
                  );
                })}
              </Box>
            )}
          >
            {transactionStatuses.map((status) => {
              const meta = getStatusMeta(status);
              return (
                <MenuItem
                  sx={{
                    gap: 1,
                    "&.Mui-selected": {
                      backgroundColor: alpha(
                        darkTheme.palette.primary.main,
                        0.14,
                      ),
                      "&:hover": {
                        backgroundColor: alpha(
                          darkTheme.palette.primary.main,
                          0.2,
                        ),
                      },
                    },
                  }}
                  value={status}
                  key={status}
                >
                  <Box
                    component="span"
                    sx={{
                      width: 9,
                      height: 9,
                      borderRadius: "50%",
                      backgroundColor: meta.color,
                      flexShrink: 0,
                    }}
                  />
                  {meta.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl sx={{ width: "100%", mt: 6 }} fullWidth>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "18px" : "20px",
              transform: "translateY(-30px)",
            }}
            id="demo-multiple-chip-label"
          >
            Выберите метод
          </InputLabel>
          <Select
            value={filterss.payment_method}
            MenuProps={{
              disableScrollLock: true,
            }}
            name="payment_method"
            onChange={(event) => handleChange(event.target.name, event)}
            sx={{ height: "68px" }}
          >
            {Object.entries(methods).map(([key, value]) => (
              <MenuItem key={key} value={value}>
                <Typography>{translate(value)}</Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 6, width: "100%" }}>
          <InputLabel
            shrink={true}
            sx={{
              fontSize: isMobile600 ? "17px" : "20px",
              transform: "translateY(-30px)",
            }}
          >
            Выберите валюту
          </InputLabel>
          <Select
            onChange={(event) => handleChange(event.target.name, event)}
            value={filterss.currency}
            MenuProps={{
              disableScrollLock: true,
            }}
            id="currency"
            name="currency"
            sx={{ height: "68px" }}
          >
            {Object.entries(currency).map(([key, value]) => (
              <MenuItem key={key} value={value.label}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography>{value?.label}</Typography>
                  <img
                    src={value?.img}
                    alt={value?.label}
                    width={35}
                    height={35}
                    style={{ objectFit: "contain" }}
                  />
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box
          sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: 5 }}
        >
          <Button
            variant="contained"
            onClick={() => {
              fetchRecentTrans();
              setOpenFilters(false);
            }}
          >
            Применить фильтры
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setFilters({
                search_query: "",
                type: [],
                merchid: [],
                providerid: [],
                minsum: null,
                maxsum: null,
                status: [],
                forMerch: false,
                createdFrom: null,
                createdTo: null,
                updatedFrom: null,
                currency: "",
                updatedTo: null,
                payment_method: "",
              });
            }}
          >
            Очистить фильтры
          </Button>
        </Box>
      </Drawer>
    </LocalizationProvider>
  );
};
export default Filters;
